// src/utils/navigation/townlitLinkResolver.ts

export type TownLITResolvedLink =
  | {
      kind: "foundation";
      slug: string;
      webPath: string;
    }
  | {
      kind: "internal";
      webPath: string;
    }
  | {
      kind: "external";
      url: string;
    }
  | {
      kind: "unsupported";
    };

const townlitHosts = new Set([
  "townlit.com",
  "www.townlit.com",
]);

const normalizePath = (path: string): string => {
  if (!path.startsWith("/")) return `/${path}`;
  return path;
};

const resolveInternalPath = (path: string): TownLITResolvedLink => {
  const normalized = normalizePath(path);

  if (normalized.startsWith("/foundation/")) {
    const slug = normalized.replace("/foundation/", "").split("?")[0].split("#")[0];

    if (!slug) {
      return { kind: "unsupported" };
    }

    return {
      kind: "foundation",
      slug,
      webPath: `/townlit-official/foundation/${slug}`,
    };
  }

  if (normalized === "/support") {
    return {
      kind: "internal",
      webPath: "/townlit-official/support",
    };
  }

  if (normalized === "/company") {
    return {
      kind: "internal",
      webPath: "/townlit-official/company",
    };
  }

  if (normalized === "/install-app") {
    return {
      kind: "internal",
      webPath: "/townlit-official/install-app",
    };
  }

  if (normalized === "/request-access") {
    return {
      kind: "internal",
      webPath: "/townlit-official/request-access",
    };
  }

  return {
    kind: "internal",
    webPath: normalized,
  };
};

export const resolveTownLITLink = (href: string | null | undefined): TownLITResolvedLink => {
  if (!href) {
    return { kind: "unsupported" };
  }

  const trimmed = href.trim();

  if (!trimmed || trimmed.startsWith("#") || trimmed.startsWith("mailto:") || trimmed.startsWith("tel:")) {
    return { kind: "external", url: trimmed };
  }

  if (trimmed.startsWith("/")) {
    return resolveInternalPath(trimmed);
  }

  try {
    const url = new URL(trimmed);

    if (url.protocol === "townlit:") {
      return resolveInternalPath(url.pathname);
    }

    if (url.protocol === "http:" || url.protocol === "https:") {
      if (townlitHosts.has(url.hostname)) {
        const path = url.pathname;

        if (path.startsWith("/townlit-official/foundation/")) {
          const slug = path.replace("/townlit-official/foundation/", "").split("/")[0];

          return {
            kind: "foundation",
            slug,
            webPath: `/townlit-official/foundation/${slug}`,
          };
        }

        if (path.startsWith("/foundation/")) {
          return resolveInternalPath(path);
        }

        return {
          kind: "internal",
          webPath: path + url.search + url.hash,
        };
      }

      return {
        kind: "external",
        url: trimmed,
      };
    }

    return { kind: "unsupported" };
  } catch {
    return { kind: "unsupported" };
  }
};